<template>
  <div>
    <div class="page-header">
      <h3>Inbox (inbox@todo.cool)</h3>
    </div>

    <TaskExpander />
    <NewQuickTask :inbox="true" />

    <ul class="mt-2 list-group">
      <draggable v-model="allTasks" @start="drag=true" @end="drag=false" handle=".sort-handle">
        <transition-group type="transition" :name="'flip-list'">
          <li v-for="task in allTasks" :key="task.id" class="list-group-item js-task-details-collapse-container" v-bind:class="{ 'bg-light': task.kind == 'comment' }">
            <QuickTask :task="task" :sortable=true />
          </li>
        </transition-group>
      </draggable>
    </ul>
  </div>
</template>

<script>
var firstBy = require('thenby');
import api from "api";
import QuickTask from "components/QuickTask";
import NewQuickTask from "components/NewQuickTask";
import TaskExpander from "components/TaskExpander";
import draggable from 'vuedraggable'

export default {
  components: {
    QuickTask,
    NewQuickTask,
    TaskExpander,
    draggable
  },
  computed: {
    allTasks: {
      set: function(value){
        value.forEach(function(item, index){
          api.updateTask(item.id, { sort: index })
        })

        return value;
      },
      get: function(){
        var tasks = this.$store.state.tasks.filter(function (task){
          return (task.project_id === null && task.completed_at == null && task.due_date == null)
        })

        return tasks.sort(firstBy("sort"))
      }
    },    
  },
};
</script>
